import { getMessengerContactValue } from "@/shared/lib/messengerContact";

const PREFIX_TO_LABEL: Record<string, string> = {
    tg: "Telegram",
    whatsapp: "WhatsApp",
    teams: "Teams",
    wechat: "WeChat",
    line: "Line",
    qq: "QQ",
};

const CONTACT_PATTERN = /^(tg|whatsapp|teams|wechat|line|qq|other):\s*(.+)$/i;

export interface ParsedContact {
    label: string | null;
    value: string;
}

export const parseManagerContact = (raw?: string): ParsedContact | null => {
    const trimmed = raw?.trim();
    if (!trimmed) return null;

    const match = trimmed.match(CONTACT_PATTERN);
    if (!match) return { label: null, value: trimmed };

    const [, prefix] = match;
    const normalizedPrefix = prefix.toLowerCase();
    const label = PREFIX_TO_LABEL[normalizedPrefix] ?? null;

    return { label, value: getMessengerContactValue(trimmed) };
};
